import { BaseWebComponentRepository } from '../../../../framework/BaseWebComponentRepository';
import { InstallAgentPanelDataProviderFactory } from '../factory/InstallAgentPanelDataProviderFactory';
import { InstallAgentPanelDataProvider } from '../dataProvider/InstallAgentPanelDataProvider';
import { LanguageData } from '../../../../packages/types/language-data';
import { GetCompanyFeaturesPayload } from '../../../../packages/types/package-data';
import { Feature } from '@nirvana/shared/constants';
import { GetPackageByIdPayload } from '../../../../utils/request';
import { GetCompanyPackagesResponse, GetPackageByIdResponse } from '../../../../utils/response';

export class InstallAgentPanelRepository extends BaseWebComponentRepository {
  public dataProviderFactory: InstallAgentPanelDataProviderFactory;
  public dataProvider: InstallAgentPanelDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new InstallAgentPanelDataProviderFactory(),
    });
  }

  public async getCompanyPackages(companyId: string): Promise<GetCompanyPackagesResponse> {
    return this.dataProvider.getCompanyPackages(companyId);
  }

  public async getPackageById(payload: GetPackageByIdPayload): Promise<GetPackageByIdResponse> {
    return this.dataProvider.getPackageById(payload);
  }

  public getLanguages(): LanguageData[] {
    return this.dataProvider.getLanguages();
  }

  public async getFeaturesByCompany(payload: GetCompanyFeaturesPayload): Promise<Feature[]> {
    return this.dataProvider.getFeaturesByCompany(payload);
  }
}
